import __vue_component__$1 from '../HseIcon/HseIcon.vue.js';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Model, Watch, Component, Vue } from 'vue-property-decorator';
import { EnumProp } from '../../utils/enumProp.js';
import __vue_component__ from '../../icons/action/arrow/dropdown/bottom/IconActionArrowDropdownBottom.vue.js';
import 'reflect-metadata';
import { CollapseColor, CollapseVariant } from './types.js';

/**
 * @figma https://www.figma.com/file/cBHD57QcCt9WDT4e7e2B3w/hse_general_library?node-id=6919%3A134
 * @storybook /?path=/story/collapse-collapse--playground
 * @react /src-components-collapse
 * @reactStorybook /?path=/story/collapse-collapse--playground
 */
var HseCollapse = /** @class */ (function (_super) {
    __extends(HseCollapse, _super);
    function HseCollapse() {
        var _a, _b;
        var _this = _super.apply(this, arguments) || this;
        _this.isActive = false;
        _this.innerIsOpen = (_b = (_a = _this.isOpen) !== null && _a !== void 0 ? _a : _this.defaultOpen) !== null && _b !== void 0 ? _b : false;
        return _this;
    }
    Object.defineProperty(HseCollapse.prototype, "toggleIcon", {
        get: function () {
            return __vue_component__;
        },
        enumerable: false,
        configurable: true
    });
    HseCollapse.prototype.handleIsOpenChanged = function (v) {
        this.innerIsOpen = v;
    };
    HseCollapse.prototype.handleDefaultOpenChanged = function (v) {
        this.innerIsOpen = v;
    };
    HseCollapse.prototype.onClick = function (e) {
        if (this.isOpen === undefined) {
            this.innerIsOpen = !this.innerIsOpen;
        }
        /**
         * Вызывается при изменении состояния открытости
         * @event toggle
         * @type {boolean}
         */
        this.$emit('toggle', !this.innerIsOpen);
        /**
         * Вызывается при изменении состояния открытости
         * @event change
         * @type {boolean}
         * @deprecated используйте `toggle`
         */
        this.$emit('change', this.innerIsOpen);
    };
    __decorate([
        Prop(EnumProp(CollapseColor.default, CollapseColor)),
        __metadata("design:type", String)
    ], HseCollapse.prototype, "color", void 0);
    __decorate([
        Prop({
            default: ''
        }),
        __metadata("design:type", String)
    ], HseCollapse.prototype, "title", void 0);
    __decorate([
        Prop({
            default: ''
        }),
        __metadata("design:type", String)
    ], HseCollapse.prototype, "content", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseCollapse.prototype, "hasMargin", void 0);
    __decorate([
        Model('toggle'),
        __metadata("design:type", Boolean)
    ], HseCollapse.prototype, "isOpen", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], HseCollapse.prototype, "defaultOpen", void 0);
    __decorate([
        Prop(EnumProp(CollapseVariant.primary, CollapseVariant)),
        __metadata("design:type", String)
    ], HseCollapse.prototype, "variant", void 0);
    __decorate([
        Prop({
            default: function () { return ({}); }
        }),
        __metadata("design:type", Object)
    ], HseCollapse.prototype, "classes", void 0);
    __decorate([
        Watch('isOpen'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], HseCollapse.prototype, "handleIsOpenChanged", null);
    __decorate([
        Watch('defaultOpen'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], HseCollapse.prototype, "handleDefaultOpenChanged", null);
    HseCollapse = __decorate([
        Component({
            name: 'HseCollapse',
            components: {
                HseIcon: __vue_component__$1
            }
        })
    ], HseCollapse);
    return HseCollapse;
}(Vue));

export default HseCollapse;
